// extracted by mini-css-extract-plugin
module.exports = {"card-container":"Card_card-container__gSChr","card":"Card_card__2x80V"};